var _circle, _circle2, _path;
var _excluded = ["svgRef", "title"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgHelp = function SvgHelp(_ref) {
  var svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5001,
    cy: 15.5001,
    r: 11.6163,
    stroke: "#343434",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 15.5,
    cy: 20.9648,
    r: 1,
    fill: "#343434",
    stroke: "#343434",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4285 10.5975C12.4115 10.611 12.4071 10.6342 12.4178 10.6532C12.4836 10.7706 12.7312 11.1917 13.1566 11.6837C13.4846 12.063 14.9468 10.2656 16.5302 11.3773C16.5393 11.3837 16.5482 11.3901 16.5569 11.3966C17.4556 12.2112 16.8605 13.577 15.3246 14.5022C14.8572 14.7838 14.4022 15.453 14.4603 15.7795C14.5184 16.1061 14.6425 17.3023 14.6425 17.3023H16.0456C16.0456 17.3023 16.2137 15.8675 16.4529 15.6537C17.4915 14.7253 17.8763 14.6958 18.4011 13.9556C18.9259 13.2154 19.4746 10.8441 17.4556 9.78258C14.9128 8.72881 12.7028 10.3802 12.4285 10.5975Z",
    fill: "#343434",
    stroke: "#343434",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgHelp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/help.353bb410.svg";
export { ForwardRef as ReactComponent };